import*as React from"react";import{Dropdown as AntdDropdown}from"antd";export const Dropdown=props=>React.createElement(AntdDropdown,props);